import { useStaticQuery, graphql } from 'gatsby';

const useFooter = () => {
  const data = useStaticQuery(graphql`
    {
      extFooter {
        footerItemList {
          text
          link
          openNewTab
        }
      }
      footer {
        copyrightText
        footerItemList {
          link
          openNewTab
          text
        }
      }
    }`);

  return {
    copyrightText: data?.footer?.copyrightText,
    footerItemList: data && [...data?.footer?.footerItemList, ...data?.extFooter?.footerItemList]
  };
};

export default useFooter;
